export type ClipboardCopyMethod = "clipboard" | "legacy";

export interface ClipboardCopyResult {
  ok: boolean;
  method: ClipboardCopyMethod | null;
}

function legacyCopy(text: string) {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.readOnly = true;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  textarea.style.pointerEvents = "none";
  document.body.appendChild(textarea);
  textarea.select();
  try {
    return typeof document.execCommand === "function" && document.execCommand("copy");
  } catch {
    return false;
  } finally {
    textarea.remove();
  }
}

/** 优先 Clipboard API；权限拒绝或旧浏览器时回退到同步 copy 命令。 */
export async function copyText(text: string): Promise<ClipboardCopyResult> {
  if (!text) return { ok: false, method: null };
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return { ok: true, method: "clipboard" };
    }
  } catch {
    // 浏览器权限策略可能拒绝 Clipboard API，继续尝试兼容回退。
  }
  return legacyCopy(text) ? { ok: true, method: "legacy" } : { ok: false, method: null };
}
